module.exports = __webpack_public_path__ + "img/MDMiphoen.8daf41d8.jpg";